export const C = {
  blue: "#3B9AE8",
  blueDark: "#2968B0",
  blueDeep: "#1E4F8A",
  blueLight: "#E8F4FD",
  bluePale: "#F0F8FF",
  yellow: "#FFD700",
  yellowLight: "#FFF8DC",
  accent: "#10B981",
  accentLight: "#D1FAE5",
  text: "#2B2B2B",
  textMid: "#555555",
  textLight: "#888888",
  bg: "#FAFBFC",
  white: "#FFFFFF",
  border: "#E5E9EF",
  danger: "#E8534A",
};
